import Api from "../classes/api";

export const api = new Api();
